import { SxProps } from '@mui/material';

export const DialogFullWidthStyle: SxProps = {
  '& .MuiDialog-paper': {
    maxWidth: '100%',
    width: '100%',
  },
  mx: 8,
  width: 'auto',
};
